(() => {
  const script = document.currentScript;
  const measurementId = 'G-1TZZG6BNVD';
  const themeId = '188712452402';
  const pendingKey = 'gj-inquiry-pending-' + themeId;
  const originKey = 'gj-inquiry-origin-' + themeId;
  const preview = script?.dataset.preview === 'true';
  const cleanPath = () => location.pathname;
  const market = path => /equipos-fibra-optica-mexico/.test(path) ? 'mexico' : /supplier-africa/.test(path) ? 'africa' : /supplier-usa/.test(path) ? 'usa' : 'general';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; } };
  const remove = key => { try { sessionStorage.removeItem(key); } catch {} };
  const forms = [...document.querySelectorAll('form')].filter(form => form.querySelector('[data-gj-inquiry-form]'));
  const state = value => forms.forEach(form => { form.dataset.gjTrackingState = value; });
  const ready = () => allowed() && typeof window.gtag === 'function';
  const send = (name, params) => {
    if (!ready()) return false;
    window.gtag('event', name, { send_to: measurementId, theme_id: themeId, theme_preview: preview ? 'true' : 'false', debug_mode: preview, ...params });
    return true;
  };
  let pending = read(pendingKey);
  const success = [...document.querySelectorAll('[data-gj-inquiry-success]')].find(node => node.dataset.gjInquirySuccess === pending?.form);
  const flush = () => {
    state(!allowed() ? 'consent-unavailable' : typeof window.gtag !== 'function' ? 'tag-unavailable' : 'ready');
    if (!pending || !success || Date.now() - pending.time > 1800000 || !ready()) return;
    remove(pendingKey);
    send('generate_lead', { form_id: pending.form, lead_source: 'website_contact', market: pending.market, landing_path: pending.origin });
    success.dataset.gjTrackingState = 'sent';
    pending = null;
  };
  forms.forEach(form => {
    form.addEventListener('submit', event => {
      if (event.defaultPrevented || !form.checkValidity() || !allowed()) return;
      const origin = read(originKey);
      const originPath = origin && Date.now() - origin.time < 1800000 ? origin.path : cleanPath();
      const saved = write(pendingKey, { form: form.querySelector('[data-gj-inquiry-form]').dataset.gjInquiryForm, time: Date.now(), market: market(originPath), origin: originPath });
      form.dataset.gjTrackingState = saved ? 'pending' : 'storage-unavailable';
    });
  });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || !allowed()) return;
    const href = link.getAttribute('href');
    if (/\/pages\/contact-us(?:[?#]|$)/.test(href) || /^#.*(?:quote|rfq)/.test(href)) write(originKey, { path: cleanPath(), time: Date.now() });
    if (/^mailto:cixiguangjia@foxmail\.com(?:[?]|$)/i.test(href)) send('bom_email_click', { market: market(cleanPath()), contact_method: 'email' });
    if (/^https:\/\/wa\.me\/8615967199490(?:[?]|$)/.test(href)) send('whatsapp_click', { market: market(cleanPath()), contact_method: 'whatsapp' });
  });
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) flush(); });
  }
  flush();
  let attempts = 0;
  const retry = setInterval(() => { flush(); if (++attempts >= 40 || ready()) clearInterval(retry); }, 500);
  document.addEventListener('visitorConsentCollected', flush);
})();